import { render, staticRenderFns } from "./adjust-columns-dialog.vue?vue&type=template&id=b1ee51ca"
import script from "./adjust-columns-dialog.vue?vue&type=script&lang=js"
export * from "./adjust-columns-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports